import { render, staticRenderFns } from "./five.vue?vue&type=template&id=b66e3c2e&scoped=true&"
import script from "./five.vue?vue&type=script&lang=js&"
export * from "./five.vue?vue&type=script&lang=js&"
import style0 from "./five.vue?vue&type=style&index=0&id=b66e3c2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66e3c2e",
  null
  
)

export default component.exports